interface CirromConfig {
  apiUrl: string;
  wsUrl: string;
  neoEnabled: number;
  workspaceEnabled: number;
  addressMergeEnabled: number;
  syncEnabled: number;
  enrichEnabled: number;
}

export function getConfig(): CirromConfig {
  return (window as any).__CIRROM_CONFIG__ || {};
}
